import { Component, Input, OnInit } from '@angular/core';
import { isNullOrUndefined } from '@pineapplelab/util';
import { IMAGES_RESOLUTIONS } from '../../utils/image-config/base/base/types';
import { AuthService } from 'src/app/service/auth/auth.service';
import { LandingPageBanner } from 'src/app/models/firebase/landingPageBanner';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit {

    @Input() bannerData: LandingPageBanner;
    imageURL: string = '';
    loading: boolean = true;
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }
    imageBanner: string = `https://firebasestorage.googleapis.com/v0/b/pineapplecms.appspot.com/o/projects%2F${this.authService.projectId}%2FimageBanner%2FimageBanner.png?alt=media`
    ngOnInit(): void {
        setTimeout(() => {
            if (isNullOrUndefined(this.bannerData)) {
                return;
            }else{
                this.imageURL = this.bannerData.img;
            }
            this.loading = false;
        }, 3000);
    }

    goToLink(link: string) {
        if (link) {
            window.open(link, '_blank');
        }else{
            this.router.navigate(['/contact']);
        }

    }

}
